__turbopack_context__.v({
  "buttonContent": "DetailHeaderActions-module-scss-module__VXp5eq__buttonContent",
  "favoriteButton": "DetailHeaderActions-module-scss-module__VXp5eq__favoriteButton",
  "wrapper": "DetailHeaderActions-module-scss-module__VXp5eq__wrapper",
});
